<div class="user-dashboard">
  <section class="dashboard page-wrapper">
    <div class="dashboard-block">
      <div
        class="dashboard-block-header d-flex align-items-baseline"
        [ngClass]="{ 'is-open': isMyApplicationsBlockOpen }"
        (click)="toggleMyApplicationsBlock()"
      >
        <h2 class="dashboard-block-title" i18n="@@My applications">
          My applications
        </h2>
        <small class="dashboard-block-count">{{ totalFilesCount }}</small>
        <button class="dashboard-block-toggler">
          <span
            class="fa-solid fa-angle-down"
            [ngClass]="{ 'fa-angle-up': isMyApplicationsBlockOpen }"
          ></span>
        </button>
      </div>
      <div
        class="dashboard-block-content"
        [ngClass]="{ 'is-open': isMyApplicationsBlockOpen }"
      >
        <app-file-list
          [businessEntity]="currentBE"
          (totalFilesCountEmitter)="updateFileCount($event)"
        ></app-file-list>
      </div>
    </div>
  </section>
</div>
